import { Flex, Image, Text } from '@chakra-ui/react'
import { TextColors } from 'commons/design-system/tokens'
import { useTranslation } from 'react-i18next'

export const PaymentSecurityInfo = ({ source }: { source: string }) => {
	const { t } = useTranslation()
	const assetsBaseUrl =
		source === 'money_pot'
			? `${process.env.REACT_APP_POTS_URL}collect/assets/img/payment`
			: `${process.env.REACT_APP_PAYMENT_FORM_URL}l/assets/img/payment`

	return (
		<Flex align='center' gap={2} py={2}>
			<Image w='20px' src={`${assetsBaseUrl}/shield.png`} alt='Shield' />
			<Text fontSize='sm' color={TextColors.SECONDARY}>
				{t('phone_form.verify_identity_security_message')}
			</Text>
		</Flex>
	)
}
